export default __webpack_public_path__ + "static/media/message_white.31be03ad.svg";